import { format, parseISO } from 'date-fns';
import { getClosedStatusLabel } from './getClosedStatusLabel';

export function translateUnitStatus(
  propertyTypeCode: string,
  statusCode: string,
  closeDate: string | null | undefined,
  isReo?: boolean,
  isShortSale?: boolean,
  isPreconstruction?: boolean,
  yearBuilt?: number
): string {
  const currentYear = new Date().getFullYear();
  const isPreconstructionData =
    isPreconstruction || Number(yearBuilt) > currentYear;

  if (propertyTypeCode !== 'R' && statusCode === 'CSL') {
    return `Coming Soon`;
  } else if (propertyTypeCode !== 'R' && statusCode === 'AC') {
    return `Accepting Backups`;
  } else if (propertyTypeCode !== 'R' && statusCode === 'PS') {
    return `Pending Sale`;
  } else if (isReo && statusCode !== 'CS' && !isPreconstructionData) {
    return `Foreclosure`;
  } else if (isShortSale && statusCode !== 'CS' && !isPreconstructionData) {
    return `Short sale`;
  } else if (
    isPreconstructionData &&
    propertyTypeCode !== 'R' &&
    statusCode === 'A'
  ) {
    return `Pre-construction`;
  } else if (propertyTypeCode !== 'R' && statusCode === 'A') {
    return `For sale`;
  } else if (
    (propertyTypeCode === 'R' && statusCode === 'A') ||
    (propertyTypeCode === 'R' && statusCode === 'AC')
  ) {
    return `For rent`;
  } else if (
    statusCode === 'PS' ||
    statusCode === 'C' ||
    statusCode === 'X' ||
    statusCode === 'T' ||
    statusCode === 'W' ||
    statusCode === 'Q'
  ) {
    return `Off market`;
  } else if (statusCode === 'R' || statusCode === 'CS') {
    return `${getClosedStatusLabel(propertyTypeCode, statusCode)} ${
      closeDate ? format(parseISO(closeDate), 'MM-dd-yyyy') : ''
    }`;
  } else {
    return '';
  }
}
